var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "horizontal-item p-3" }, [
        _c("div", { staticClass: "d-md-flex justify-content-between" }, [
          _c("div", { staticClass: "d-md-flex" }, [
            _c(
              "div",
              { staticClass: "position-relative" },
              [
                _c("small-carousel", {
                  attrs: {
                    images: _vm.images,
                    "show-indicators": false,
                    height: "160px"
                  }
                }),
                _vm._v(" "),
                _vm.isOffertaSpeciale
                  ? _c("div", { staticClass: "circle-area" }, [
                      _c("p", [_vm._v("Offerta Speciale")])
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "position-relative" }, [
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "type-info",
                    class: _vm.isHighlight ? "bg-primary" : ""
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.label))])]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex" }, [
                  _c("div", { staticClass: "date-info" }, [
                    _c("h1", { staticClass: "m-0" }, [_vm._v(_vm._s(_vm.day))]),
                    _vm._v(" "),
                    _c("h5", { staticClass: "text-uppercase m-0" }, [
                      _vm._v(_vm._s(_vm.month))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-info" }, [
                    _c("h3", [_vm._v(_vm._s(_vm.name))])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass:
                      "detail-info d-md-flex justify-content-around mb-2"
                  },
                  [
                    _c("div", [
                      _c("span", { staticClass: "notti nowrap" }, [
                        _c("b", [_vm._v(_vm._s(this.nights))]),
                        _vm._v(" notti -\n                  "),
                        _c("b", [_vm._v(_vm._s(this.days))]),
                        _vm._v(" giorni\n                ")
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.isPartenzaGarantita
                      ? _c("div", [
                          _vm.isPartenzaGarantita
                            ? _c(
                                "span",
                                { staticClass: "partenza-garantita" },
                                [_vm._v("partenza garantita")]
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "mb-2 mb-md-0 dates-info d-md-flex justify-content-around"
                  },
                  [
                    _vm.isAltreDate
                      ? _c("div", { staticClass: "position-relative" }, [
                          _c(
                            "a",
                            {
                              staticClass: "dates text-primary",
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  _vm.showAltreDate = !_vm.showAltreDate
                                }
                              }
                            },
                            [_vm._v("altre date disponibili")]
                          ),
                          _vm._v(" "),
                          _vm.showAltreDate
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "position-absolute p-1 border rounded bg-white text-center",
                                  staticStyle: {
                                    "z-index": "10",
                                    "max-height": "130px",
                                    overflow: "auto"
                                  },
                                  on: {
                                    mouseleave: function($event) {
                                      _vm.showAltreDate = false
                                    },
                                    click: function($event) {
                                      _vm.showAltreDate = false
                                    }
                                  }
                                },
                                _vm._l(_vm.departureFutureDates, function(
                                  item,
                                  index
                                ) {
                                  return _c(
                                    "button",
                                    {
                                      key: index,
                                      staticClass:
                                        "rounded-0 m-1 px-1 btn btn-outline-primary btn-sm nowrap",
                                      staticStyle: { width: "45px" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onOpenDetailWithDate(item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.formatDate(item)) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              { staticClass: "position-relative text-center pt-2 pt-md-0" },
              [
                _c("h6", { staticClass: "text-uppercase" }, [
                  _vm._v("a partire da")
                ]),
                _vm._v(" "),
                _c("h1", { staticClass: "currency" }, [
                  _vm._v(_vm._s(_vm.price) + " €")
                ]),
                _vm._v(" "),
                _c(
                  "small",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isVoloRequested,
                        expression: "isVoloRequested"
                      }
                    ],
                    staticClass:
                      "w-100 text-center position-absolute text-uppercase mb-1",
                    staticStyle: { bottom: "-20px", left: "0" }
                  },
                  [_vm._v("volo incluso")]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary px-5",
                  attrs: { id: "scegliTour" },
                  on: { click: _vm.onOpenDetail }
                },
                [_vm._v("\n            scegli\n          ")]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("ModalTourDetail", {
        ref: "modalTourDetail",
        attrs: {
          value: _vm.value,
          "is-home-page": true,
          "is-camere-requested": _vm.isHomePage
        },
        on: { select: _vm.onSelect }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eb576aa6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb576aa6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/tours/HorizontalItemTour.vue
// module id = null
// module chunks = 